module.exports = __webpack_public_path__ + "img/01.ee380e0e.jpg";